import EventEmitter from "../../../node_modules/eventemitter3/index";
import { Stage, StagesClient } from "../client/Client";
import EventList from "../Events/EventList";
import { TableFactory, TableInterface } from "../Utilities/Table";


let strategySelect = <HTMLSelectElement>document.querySelector("#strategy");
export default class StagesTableComponent{
    /**
     *
     */

    dtConfiguration = [
        {
            targets: 0,
            data: "id"
        },
        {
            targets: 1,
            data: "name"
        },
        {
            targets: 2,
            data: "isFinal",
            render: (isFinal: boolean) => isFinal? "Si": "No" 

        },
        {
            targets: 3,
            data: "isEditable",
            render: (isFinal: boolean) => isFinal? "Si": "No" 

        },
        {
            targets: 4,
            data: "strategy",
            render: (strategy: number) => {
                return Array.from(strategySelect.options).find(e=>e.value == strategy.toString()).innerText
            } 

        },
        {
            targets: 5,
            data: "cssIcon",
            render: (cssIcon: string) => {
                return `<span class="${cssIcon}"></span>`
            } 

        },
        {
            targets: 6,
            data: "id",
            render: (id: number, _,stage: Stage) =>{
                console.log(stage);
                return  `<button class='btn btn-primary stage-edit' data-stage-id="${id}"><i class='fas fa-edit'></i></button>`+(stage.isEditable?`<button class='btn btn-primary stage-delete ml-1'><i class='fas fa-trash'></i></button>`: "" )
            } 
        }
    ]

    selectedStage:Stage=null;
    selectedRow: HTMLTableRowElement= null;

    table: TableInterface<Stage>
    constructor(private eventEmitter: EventEmitter, private tableFactory: TableFactory<Stage>, private stageClient: StagesClient) {

        this.eventEmitter.on(EventList.STAGES_FETCHED, this.init)
        this.eventEmitter.on(EventList.STAGE_UPDATED,this.updateStageHandler)
        this.eventEmitter.on(EventList.STAGE_CREATED,this.addStage)
        $(document).on("click",".stage-delete",this.deleteStageHandler)
        $(document).on("click",".stage-edit",this.editHandler)
                
    }

    updateStageHandler = (stage: Stage)=>{
        let target = <HTMLButtonElement>document.querySelector(`button[data-stage-id='${stage.id}']`)
        this.selectedRow = target.closest("tr");
        this.table.UpdateRow(this.selectedRow,stage);
        this.table.Draw();
    }

    deleteStageHandler = (evt: Event)=>{
        let target = <HTMLElement>evt.target;
        this.selectedRow = target.closest("tr");

        this.selectedStage = this.table.GetData(this.selectedRow);
        Alerta.SwalConfirm("Deseas eliminar esta etapa?",this.deleteStage,()=>{},2)
    }

    editHandler = (evt: Event)=>{
        let target = <HTMLElement>evt.target;
        this.selectedRow = target.closest("tr");
        this.selectedStage = this.table.GetData(this.selectedRow);

        this.eventEmitter.emit(EventList.STAGE_SELECTED,this.selectedStage)
    }

    deleteStage= async() =>{
        try{

            await this.stageClient.delete(this.selectedStage.id);
            this.eventEmitter.emit(EventList.STAGE_DELETED, this.selectedStage.id);
            this.table.DeleteRow(this.selectedRow);
            this.table.Draw();
            this.selectedStage = null;

        }
        catch(ex){
            Notify.error("Error al Eliminar Etapa");
        }
    }

    init = (stages: Stage[])=>{
        if(!this.table){
            this.table = this.tableFactory.Init(stages,"#stages-table",this.dtConfiguration); 
        }
        else{
            this.table.Reset(stages);
            this.table.Draw();
        }
        
    }

    addStage = (stage: Stage)=>{
        this.table.AddRow(stage);
        this.table.Draw();
    }
}